import type {IntRange} from '#types/numbers.js';
import type {ValuesFor} from '#types/util.js';

export const BASE_UNIT = 2;
export const SPACING_UNIT = BASE_UNIT * 6;

export const Size = {
  One: 1,
  Two: 2,
  Three: 3,
  Four: 4,
  Five: 5,
  Six: 6,
  Seven: 7,
  Eight: 8,
  Nine: 9,
  Ten: 10,
  Eleven: 11,
  Twelve: 12,
  Thirteen: 13,
  Fourteen: 14,
  Fifteen: 15,
  Sixteen: 16,
  TwentyOne: 21,
} as const;

export type Size = ValuesFor<typeof Size>;

export type SizeUpTo<N extends number> = Extract<Size, IntRange<0, N>>;

export const sizeVarMap = Object.fromEntries(
  Object.values(Size).map(size => [size, `var(--space-${size})`])
) as Record<Size, string>;

export type SizeString =
  | `${number}px`
  | `${number}rem`
  | `${number}em`
  | `${number}%`
  | `${number}cqw`;
